import React from 'react'
import { Container, Tabs } from '@cleartrip/ct-design-components'

const FlightDetailsTab = ({ selectedTab, setSelectedTab }) => {
    const tabList = [
        {
            tabKey: 0,
            label: 'Itinerary'
        },
        {
            tabKey: 1,
            label: 'Fare rules'
        }
    ]
    const onTabClick = (e, tab) => {
        setSelectedTab(tab.tabKey)
    }

    return (
        <Container className="mt-2">
            <Tabs
                tabList={tabList}
                selectedTabIndex={selectedTab}
                tabSize="large"
                onClick={onTabClick}
                styleConfig={{
                    root: {
                        css: {
                            paddingLeft: '16px'
                        }
                    },
                    tabItem: {
                        root: {
                            css: {
                                width: '284px',
                                textAlign: 'left'
                            }
                        }
                    }
                }}
            />
        </Container>
    )
}

export default FlightDetailsTab
